var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"contenuAdmin"}},[_c('MenuAdmin',{attrs:{"id":"menuTop"}}),_c('div',{attrs:{"id":"main"}},[_c(_vm.layout,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }